export default {
  Play: '.iono-player-play',
  Pause: '.iono-player-pause',
  Mute: '.iono-player-mute',
  Next: '.iono-player-next',
  Previous: '.iono-player-previous',
  Unmute: '.iono-player-unmute',
  Position: '.iono-player-position',
  Duration: '.iono-player-duration',
  TogglePlay: '.iono-player-toggle-play',
  ToggleMute: '.iono-player-toggle-mute',
  MetaTitle: '.iono-player-metadata-title',
  MetaSubtitle: '.iono-player-metadata-subtitle',
  MetaCreator: '.iono-player-metadata-creator',
  MetaGrouping: '.iono-player-metadata-grouping',
  Quality: '.iono-player-quality',
  Volume: '.iono-player-volume',
  Timeline: '.iono-player-timeline',
  TimelineSlider: '.iono-player-timeline-slider',
  Advertisement: '.iono-player-advertisement',
  Sharing: '.iono-player-sharing',
  Content: '.iono-player-content',
  Item: '.iono-playlist-item',
  Items: '.iono-playlist-items',
  Repeat: '.iono-playlist-repeat',
  Selected: '.iono-selected',
  Playlist: '.iono-playlist',
  Download: '.iono-player-download',
  Skip: '.iono-player-skip',
  AdPosition: '.iono-player-adposition',
  AdDuration: '.iono-player-adduration',
  SelectToggle: '.iono-select-toggle',
  SelectOptions: '.iono-select-options',
  SelectOption: '.iono-select-option',
  SelectLabel: '.iono-select-label',
  ShareFacebook: '.iono-select-option[data-value="facebook"]',
  ShareTwitter: '.iono-select-option[data-value="twitter"]',
  ShareWhatsApp: '.iono-select-option[data-value="whatsapp"]',
  ShareEmail: '.iono-select-option[data-value="email"]',
  SliderContainer: '.iono-slider-container',
  SliderKnob: '.iono-slider-knob',
  SliderProgress: '.iono-slider-progress',
  SliderTrack: '.iono-slider-track',
  BufferedProgress: '.iono-player-buffered-progress',
  Forward: '.iono-player-forward',
  Backward: '.iono-player-backward',
  Error: '.iono-player-error',
  Artwork: '.iono-player-coverart'
};
